import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Divider, Form, Input, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import _ from 'lodash'
import { RootDispatch } from '../../app/store'
import React from 'react'
import { EditableList } from '../../compnents/list/EditableList'
import { BillCodeDetailColumns } from './columns'
import styles from './putstorage.module.css'
import { getBindMSFXListDetailAsync, setPageLoading } from './putstorageSlice'
import moment from 'moment'
import { DateTimeFormatSimpleOnly, DateTimeFormatSimpleOnlyOne } from '../../models/datetime'

export const BillCodeDetailModal = (props: {
  detailParam?: any
  visible?: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [page, setPage] = useState<any>()

  const [pageLoading, setPageLoading] = useState<boolean>(false)

  useEffect(() => {
    if (props?.visible) {
      setPageLoading(true)
      dispatch(getBindMSFXListDetailAsync(props?.detailParam))
        .then(unwrapResult)
        .then((res: any) => {
          const list = res?.map((v: any) => {
            return {
              ...v,
              storeOutDate: v?.storeOutDate ? moment(v?.storeOutDate).format(DateTimeFormatSimpleOnlyOne) : '-',
            }
          })?.[0]
          setPage(list)
        })
        .finally(() => {
          setPageLoading(false)
        })
    } else {
      form.resetFields()
      setPage([])
    }
  }, [props.visible])

  return (
    <>
      <Modal
        width={1450}
        className={styles.modalContent}
        title={'发货单详情'}
        visible={props.visible}
        footer={null}
        centered
        maskClosable={false}
        onOk={() => {
          props.onOk()
        }}
        onCancel={() => {
          props.onCancel()
        }}
        destroyOnClose
      >
        <div style={{ height: '620px', overflowY: 'hidden' }}>
          <div
            className={styles.titleStyle}
          >
            <div>供应商：{page?.entSendName || '-'}，发货时间：{page?.storeOutDate || '-'}，码上放心发货单号：{page?.billCode || '-'} </div>
          </div>
          <div>
            <EditableList
              loading={pageLoading}
              pagination={false}
              style={{
                border: '1px solid #f0f0f0',
                borderBottom: 'none',
                height: '92%',
                overflowY: 'auto',
              }}
              page={{
                current: 1,
                size: 10,
                total: 0,
                items: page?.drugInfosDtoList,
              }}
              size='small'
              columns={
                BillCodeDetailColumns()
              }
            />
          </div>

        </div>
      </Modal >
    </>
  )
}
